import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Chip,
} from '@material-ui/core';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import useApi from '../../../utils/useApi';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import StoreContext from '../../Store/context';

const CashierSelect = (children) => {
  const { credencials, setCredencials } = useContext(StoreContext);
  const { open, handleModal } = children;
  const [modalValues, setModalValues] = useState();
  const history = useHistory();

  const [cashierLoad, cashierInfo] = useApi({
    method: 'get',
    url: '/cash-registers',
    params: { isActive: 1, userId: credencials.id },
  });

  useEffect(() => {
    if (open) {
      cashierLoad();
      setModalValues(credencials.cashSession);
    }
  }, [open]);

  function closeModal() {
    handleModal();
  }

  function onChange(value) {
    setModalValues(value);
  }

  function onRemove() {
    setCredencials({ ...credencials, cashSession: 0 });
    onChange(0);
    closeModal();
  }

  function onSubmit() {
    const cashSession = modalValues || 0;
    setCredencials({ ...credencials, cashSession });
    closeModal();

    if (cashSession && cashierInfo.data) {
      const selectedCashier = cashierInfo.data.find(
        (c) => String(c.id) === String(cashSession)
      );
      if (
        selectedCashier &&
        (selectedCashier.isOpen === '0' ||
          selectedCashier.isOpen === 0 ||
          !selectedCashier.isOpen)
      ) {
        history.push('/home/caixas/detalhes');
      }
    }
  }

  const renderStatusChip = (isOpen) => {
    if (isOpen) {
      return (
        <Chip
          icon={<LockOpenIcon style={{ color: '#fff', fontSize: '0.85rem' }} />}
          label="Aberto"
          size="small"
          style={{
            backgroundColor: '#2E7D32',
            color: '#fff',
            fontWeight: 'bold',
            height: 22,
            fontSize: '0.72rem',
          }}
        />
      );
    }
    return (
      <Chip
        icon={<LockIcon style={{ color: '#fff', fontSize: '0.85rem' }} />}
        label="Fechado"
        size="small"
        style={{
          backgroundColor: '#757575',
          color: '#fff',
          fontWeight: 'bold',
          height: 22,
          fontSize: '0.72rem',
        }}
      />
    );
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={closeModal}
      maxWidth="xs"
      PaperProps={{ className: children.isDark ? 'pos-dark-paper' : '' }}
    >
      <UIDialogTitle id="form-dialog-title" onClose={closeModal}>
        {credencials.cashSession
          ? 'Alterar caixa sessão'
          : 'Selecionar caixa da sessão'}
      </UIDialogTitle>
      <DialogContent>
        <Grid
          item
          container
          direction="row"
          justify="space-between"
          className="UIModalFilter__content"
          alignItems="center"
          xs={12}
        >
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel shrink id="cashier-select">
                Nome do caixa
              </InputLabel>
              <Select
                value={cashierInfo.data ? modalValues : 0}
                disabled={cashierInfo.loading}
                defaultValue=""
                onChange={(ev) => onChange(ev.target.value)}
                labelId="cashier-select"
                displayEmpty
                MenuProps={{
                  PaperProps: {
                    className: children.isDark ? 'pos-dark-paper' : '',
                  },
                }}
                renderValue={(selected) => {
                  if (!selected || selected === 0) {
                    return 'Informe o nome do caixa';
                  }
                  const found = cashierInfo.data?.find((c) => c.id === selected);
                  if (!found) return 'Informe o nome do caixa';
                  const isOpen =
                    found.isOpen === '1' ||
                    found.isOpen === 1 ||
                    found.isOpen === true;
                  return (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        paddingRight: 8,
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{found.name}</span>
                      {renderStatusChip(isOpen)}
                    </div>
                  );
                }}
              >
                <MenuItem disabled key={-1} value={0}>
                  Informe o nome do caixa
                </MenuItem>
                {cashierInfo.data &&
                  cashierInfo.data.map((cashier) => {
                    const isOpen =
                      cashier.isOpen === '1' ||
                      cashier.isOpen === 1 ||
                      cashier.isOpen === true;
                    return (
                      <MenuItem
                        key={cashier.id}
                        value={cashier.id}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          gap: 16,
                          padding: '8px 16px',
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>{cashier.name}</span>
                        {renderStatusChip(isOpen)}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button className="UIModal__button-delete" onClick={onRemove}>
          Remover
        </Button>
        <Button className="UIModal__button-search" onClick={onSubmit}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CashierSelect;
